// 30-09 (Pau: «las imágenes que me envían los agentes se me abren en otra pestaña; ¿es difícil que se abra en la
// misma, como un pop-up?»). La miniatura de una imagen del chat (o de un informe) que la abre en grande encima.
//
// 04-11-2026 — ya no hay un visor de imágenes propio: todo se abre en la hoja de vista previa única
// (archivos/HojaVistaPrevia.tsx, montada por OficinaPage).
import { t } from '../../../i18n';
import { elementoImagen, useVistaPrevia } from '../archivos/vistaPrevia';

/**
 * Una miniatura que abre la imagen en la hoja de vista previa (con teclado también: es un botón). `alAbrir` la abre con
 * su grupo (las demás imágenes del mismo mensaje, para ←/→); sin él, sola.
 */
export function MiniaturaImagen({ src, nombre, alFallar, alAbrir }: { src: string; nombre: string; alFallar?: () => void; alAbrir?: () => void }) {
  const abrir = useVistaPrevia((s) => s.abrir);
  return (
    <button
      type="button"
      onClick={alAbrir ?? (() => abrir({ elementos: [elementoImagen(src, nombre)], indice: 0 }))}
      className="block w-full cursor-zoom-in outline-none focus-visible:ring-2 focus-visible:ring-oficina-texto"
      aria-label={t('oficinaV2.vistaPrevia.ver', { nombre })}
    >
      <img src={src} alt={nombre} className="max-h-72 w-full object-cover" loading="lazy" onError={alFallar} />
    </button>
  );
}
